import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

export function ExpiredBadge(): ReactElement | null {
  return (
    <div className="d-flex justify-content-center  w-100 mt-4px">
      <span
        className="badge rounded-pill badge-secondary fs-12"
        style={{ paddingTop: '2px', paddingBottom: '2px', bottom: '2px' }}
        data-e2e="expired-price"
      >
        <FormattedMessage id="streaming.expired.price" />
      </span>
    </div>
  );
}
